/*
* <license header>
*/

import React from 'react'

const logoUrl = new URL('../assets/appbuilder-factory-logo.png', import.meta.url).href

/**
 * AppBuilder Factory logo - Rosie the Riveter inspired emblem with
 * AppBuilder Factory branding.
 */
export const Logo = ({ className, width, height }) => (
  <img
    src={logoUrl}
    alt="AppBuilder Factory"
    width={width}
    height={height}
    className={className}
    style={{ display: 'block', objectFit: 'contain' }}
  />
)
